import { render, staticRenderFns } from "./whiteModel.vue?vue&type=template&id=b46b2412"
import script from "./whiteModel.vue?vue&type=script&lang=js"
export * from "./whiteModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b46b2412')) {
      api.createRecord('b46b2412', component.options)
    } else {
      api.reload('b46b2412', component.options)
    }
    module.hot.accept("./whiteModel.vue?vue&type=template&id=b46b2412", function () {
      api.rerender('b46b2412', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/whiteManage/whiteModel.vue"
export default component.exports